// Vue JS
import { generateCodeFrame } from "vue-template-compiler";
import Vue from "vue/dist/vue.esm.js";
// import { filter } from "vue/types/umd";

//import ExampleComponent from "./components/ExampleComponent.vue";
import ForhandlerVelger from "./components/ForhandlerVelger.vue";
new Vue({
  el: "#app_id_0",
  components: {
    ForhandlerVelger,
  },
});
new Vue({
  el: "#app_id_1",
  components: {
    ForhandlerVelger,
  },
});
window.addEventListener("DOMContentLoaded", (event) => {
  //remove nav border
  // FIX THIS
  // var navEl = document.querySelector("#top-nav");
  // var lastEl = navEl.children[0].querySelectorAll(".nav-level-1")[navEl.children[0].querySelectorAll(".nav-level-1").length - 1];
  // if (lastEl) {
  //     lastEl.querySelector(".pl-8").style.borderWidth = "0";
  // }

  //husfilter
  var husFilter = document.querySelector("#husFilter");
  if (husFilter) {
    // console.log(husFilter);
    husFilter.onchange = function() {
      // console.log(husFilter.options[husFilter.selectedIndex].value);
      var currentValue = husFilter.options[husFilter.selectedIndex].value;
      document.querySelectorAll(".hus-container").forEach((element) => {
        if (currentValue == "all") {
          element.style.display = "flex";
        } else {
          if (element.getAttribute("data-category").includes(currentValue)) {
            element.style.display = "flex";
          } else {
            element.style.display = "none";
          }
        }
      });
    };
  }

  //movehouseTable
  if (window.innerWidth <= 1280) {
    var table = document.querySelector("#houseTable");
    if (table) {
      document.querySelector("#tableMobileContainer").appendChild(table);
    }
  }

  //left nav resize
  if (window.innerWidth >= 1280) {
    var nav = document.querySelector("#top-nav");
    var logoContainer = document.querySelector("#logo-container");
    /* console.log(
      "nav-height: " +
        nav.offsetHeight +
        "::" +
        "logoHeight: " +
        logoContainer.offsetHeight
    ); */
    if (nav.offsetHeight + logoContainer.offsetHeight > window.innerHeight) {
      logoContainer.style.justifyContent = "flex-start";
      logoContainer.style.height = "76px";
      logoContainer.children[0].style.margin = "16px auto 16px auto";
      logoContainer.children[0].style.width = "60px";
      nav.querySelectorAll("a").forEach((element) => {
        element.style.paddingTop = "0.75rem";
        element.style.paddingBottom = "0.75rem";
      });
    }
  } else {
    var prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
      var currentScrollPos = window.pageYOffset;
      if (window.pageYOffset >= 76) {
        if (prevScrollpos > currentScrollPos) {
          document.getElementsByTagName("header")[0].style.top = "0";
        } else {
          document.getElementsByTagName("header")[0].style.top = "-76px";
        }
      }
      prevScrollpos = currentScrollPos;
    };
  }

  var dropdown = document.querySelector("#dropdown-mobile");
  if (dropdown) {
    dropdown.addEventListener("click", function() {
      dropdown.children[1].classList.toggle("max-h-1000");
      document.querySelector("#dropdown-arrow").classList.toggle("rotate-180");
    });
  }

  var pluss = document.querySelector("#pluss");
  var hamburgerIcon = document.querySelector("#hamburger");
  var cart = document.querySelector("#cart");
  var book = document.querySelector("#book");
  var magnifier = document.querySelector("#magnifier");
  var sideMenu = document.querySelector("#side-menu");
  if (pluss) {
    pluss.addEventListener("click", function() {
      sideMenu.classList.add("h-64");
      pluss.classList.add("hidden");
      hamburgerIcon.classList.remove("hidden");
      cart.classList.remove("hidden");
      book.classList.remove("hidden");
      magnifier.classList.remove("hidden");
    });
  }

  var openSearch = document.querySelector("#open-search");
  var searchModal = document.querySelector("#search-modal");
  var searchIcon = document.querySelector("#search-icon");
  var closeSearch = document.querySelector("#close-search");
  if (openSearch) {
    openSearch.addEventListener("click", function() {
      searchModal.classList.toggle("hidden");
      searchIcon.classList.toggle("hidden");
      closeSearch.classList.toggle("hidden");
    });
  }

  var hamburger = document.querySelector(".hamburger");
  var hamMenu = document.querySelector("#mega-menu");
  //#TODO: fix click outside nav to close
  // document.addEventListener("click", function (e) {
  //   if (hamburger.classList.contains("is-active")) {
  //     if (!e.target.closest("#mega-menu")) {
  //       console.log("closing menu");
  //       hamMenu.classList.add("hidden");

  //       hamburger.classList.remove("is-active");
  //     }
  //   }
  // });
  if (hamburger) {
    hamburger.addEventListener("click", function(e) {
      e.preventDefault();
      this.classList.toggle("is-active");
      hamMenu.classList.toggle("hidden");
    });
  }

  var navToggle = document.querySelector("#nav-toggle");
  var navMobile = document.querySelector("#top-nav");
  var body = document.querySelector("body");
  navToggle.addEventListener("click", function(e) {
    navToggle.classList.toggle("nav-open");
    navMobile.classList.toggle("hidden");
    body.classList.toggle("fixed");
  });
  var navs = document.querySelectorAll(".nav-level-1");
  if (window.innerWidth >= 1280) {
    navs.forEach((nav) => {
      nav.addEventListener("mouseover", function(e) {
        var childs = nav.childNodes[1];
        if (childs) {
          childs.classList.remove("hidden");
          childs.classList.remove("xl:hidden");
        }
      });
      nav.addEventListener("mouseout", function(e) {
        var childs = nav.childNodes[1];
        if (childs) {
          childs.classList.add("hidden");
          childs.classList.add("xl:hidden");
        }
      });
    });
  } else {
    navs.forEach((nav) => {
      nav.addEventListener("click", function(e) {
        var childs = nav.childNodes[1];

        if (childs) {
          e.preventDefault();
          if (childs.classList.contains("hidden")) {
            childs.classList.remove("hidden");
          } else {
            childs.classList.add("hidden");
          }
        }
      });
    });
  }

  var navElements = document.querySelectorAll(".nav-list li.level-1");
  navElements.forEach((el) => {
    if (el.classList.contains("sub-nav-list")) {
      el.addEventListener("click", function(e) {
        e.preventDefault();
        el.querySelectorAll(".sub-nav-list").forEach((subList) => {
          subList.style.display = "flex";
        });
      });
    }
  });

  //margin article hack
  var grayBg = document.querySelector("div.bg-bygg-gray");
  if (grayBg) {
    // console.log(grayBg.querySelectorAll("section.bg-bygg-gray"));
    grayBg.querySelectorAll(".fiveArticle").forEach((x) => {
      x.style.margin = 0;
      x.style.paddingTop = 0;
    });
  }
  if (window.innerWidth < 1280) {
    var navElements = document.querySelectorAll("ul li.level-1");
    navElements.forEach((element) => {
      for (let child of element.children) {
        if (child.classList.contains("sub-nav-list")) {
          element.addEventListener("click", function(e) {
            // console.log("not preventing123");
            if (
              element.classList.contains("level-1") ||
              element.classList.contains("a-level-1")
            ) {
              // console.log("not preventing");
              if (
                !element.classList.contains("active") &&
                element.classList.contains("hasChildren")
              ) {
                e.preventDefault();
                // console.log("preventing");
              } else {
                // console.log("not preventing");
              }
              child.style.display = "flex";
              element.classList.add("active");
              // child.style.pointerEvents = "none";
              // for (let subEl of element.getElementsByTagName("*")) {
              //     subEl.style.border = "none!important";
              // };
              var subElList = element.getElementsByTagName("*");
              for (let i = 0; i < subElList.length; i++) {
                subElList[i].style.borderBottom = "none";
              }
            } else {
            }
          });
        }
      }
    });
  }
});
//filter partners
